function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#step1_svg__clip0_193_15663)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.076 9.059C-.01 8.914 0 8.754 0 8.594V1.539C.002.532.55.001 1.581 0c4.27 0 8.538-.003 12.808.003.39 0 .796.004 1.083.344.096.24 0 .363-.246.396-.555-.293-1.158-.266-1.762-.265C9.657.482 5.85.483 2.043.476c-.51 0-.964.087-1.313.48-.187.193-.227.443-.226.686.001 2.443-.062 4.886.034 7.329-.106.352-.126.356-.462.088z",
  fill: "#B7D6C6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.295.694a.462.462 0 00.177-.346c.391.24.523.615.524 1.038.005 2.44.004 4.882.002 7.323 0 .626-.37 1.087-.961 1.229-.154.076-.318.038-.477.038-4.483.003-8.965.002-13.447.002C.396 9.969.097 9.704.085 9.072l-.009-.014c.123-.114.246.237.369 0a.167.167 0 01.16.01c.393.464.903.569 1.498.566 3.813-.016 7.626-.015 11.438-.002.657.001 1.293-.006 1.842-.422.147.007.244-.033.278-.201.03-.158.045-.315.045-.474v-6.82c0-.23-.028-.458-.066-.685 0-.006-.026-.013-.038-.01-.012.004-.023.018-.036.029-.22-.023-.289-.157-.27-.354z",
  fill: "#B9D6CB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.958 9.943c4.693-.002 9.386-.004 14.079-.004-.068.105-.178.084-.278.084-4.6-.002-9.2-.006-13.8-.01-.02-.015-.026-.03-.02-.046.007-.015.013-.023.019-.023v-.001z",
  fill: "#B2D1D3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.471 9.235c-.408.443-.916.54-1.51.538-4.077-.02-8.153-.013-12.23-.006-.555 0-.969-.189-1.201-.702.09-.144-.018-.416.28-.43.305.506.764.652 1.344.65 3.932-.014 7.863-.007 11.795-.008.919 0 1.206-.285 1.207-1.208.005-2.019.005-4.037 0-6.055-.002-.88-.303-1.18-1.197-1.181C9.909.824 5.859.84 1.81.823c-.359-.002-.617.156-.808.441-.072.108-.106.243-.23.312C.431 1.4.663 1.107.62.87.94.491 1.343.337 1.85.34c4.012.012 8.024.012 12.036 0 .512-.002.993.025 1.407.357l.266.35c.153.11.152.278.175.437.006 2.375.002 4.75.002 7.125-.003.245-.048.473-.268.629l.002-.002z",
  fill: "#CFEEDC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.708 8.626c-.04.154.108.381-.177.439a1.41 1.41 0 01-.086-.005 2.17 2.17 0 01-.093-.64c.005-2.22.006-4.438 0-6.658 0-.33.06-.63.27-.893.172.216.048.466.086.697.166.162.141.374.142.574.004 1.97.004 3.942 0 5.912 0 .2.025.411-.14.574H.708z",
  fill: "#CFEDE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.653 1.392c-.03-.116-.06-.232-.092-.349l-.02-.311c.182.065.206.19.232.358.101.68.047 1.36.051 2.039.01 1.814.004 3.628.003 5.441 0 .244.005.487-.148.704-.115.163-.154.047-.208-.04l.182-.52c.064-.092.042-.196.043-.296V1.687c0-.1.021-.204-.043-.296z",
  fill: "#B7D6C6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.708 8.626v-7.06C1.038.777 1.172.693 2.1.693h11.978c.847 0 1.219.36 1.219 1.182v6.363c0 .8-.374 1.175-1.172 1.175-4.022 0-8.045-.012-12.067.011-.657.004-1.104-.196-1.35-.798z",
  fill: "#B6D5C5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.653 1.392c.133.114.084.268.084.407.003 2.169.003 4.337 0 6.507 0 .139.049.293-.084.408V1.392z",
  fill: "#B9D6CB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.311 8.714c-.053.047-.114.136-.158.13-.147-.024-.092-.16-.093-.248-.003-1.001-.012-2.003.006-3.004.008-.429-.198-.978.099-1.252.271-.25.816-.066 1.24-.073.72-.011 1.442.006 2.163-.008.279-.005.39.072.387.366-.013 1.307-.003 2.612-.008 3.918 0 .116.07.29-.123.322-.165.028-.106-.185-.21-.237-.272-.265-.657-.3-.978-.465-.08-.063-.121-.154-.176-.235-.046-.063-.103-.116-.146-.182a.469.469 0 01-.05-.171.777.777 0 01.003-.182c.021-.165.122-.294.2-.432.073-.135.196-.238.25-.385a.447.447 0 00-.05-.488.333.333 0 01-.006-.182c.118-.466-.063-.828-.454-.905-.47-.092-.889.187-.962.643-.023.141-.008.287-.044.426-.078.25-.081.487.127.686.083.112.139.239.205.36.037.072.072.145.099.222.026.08.034.162.034.246a.39.39 0 01-.073.235c-.229-.003-.148.259-.288.332-.333.184-.762.202-.993.562v.001z",
  fill: "#E3EEFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.24 8.885c-1.266 0-2.532-.003-3.798.004C6.18 8.89 5.995 8.88 6 8.53c.005-.325.17-.337.418-.336 2.547.004 5.094.001 7.64.003.17 0 .363-.04.435.194.101.32-.018.492-.367.492-1.295.004-2.59.001-3.886.002z",
  fill: "#7CB798"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.103 4.965H6.264c-.226 0-.438.032-.432-.316.005-.321.199-.295.41-.295h7.767c.21 0 .405-.027.41.295.006.348-.206.316-.432.316h-3.884z",
  fill: "#7DB797"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.234 6.275l-3.8.001c-.227 0-.439.03-.432-.317.005-.32.198-.298.41-.298 2.563.001 5.126.002 7.69 0 .21 0 .404-.027.41.295.005.346-.204.32-.432.318h-3.845v.001z",
  fill: "#7FB698"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.235 7.582c-1.251 0-2.503 0-3.755-.002-.223 0-.483.075-.477-.316.005-.364.244-.294.453-.295h7.6c.207 0 .448-.073.455.293.006.39-.25.318-.475.318-1.267.002-2.533 0-3.8 0v.002z",
  fill: "#7EB697"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.191 1.394l8.224-.002c.095.6.064.635-.54.583-.183-.115-.39-.113-.596-.112H7.136c-.191 0-.385-.013-.556.1-.166.044-.329.062-.48-.049l.01-.014c-.104-.19-.05-.354.081-.507v.001z",
  fill: "#E36E62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.613 3.114H6.9c-.097-.551-.072-.586.453-.588.204 0 .41-.018.612.025.197.124.42.112.64.112 1.456 0 2.911-.002 4.367.002.203 0 .413-.03.606.067.122.117.102.247.036.381l-.001.001z",
  fill: "#E37065"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.88 1.904c.44.096.616-.078.534-.512.172.183.058.404.084.608-.092.066-.198.043-.298.043H6.403c-.1 0-.207.02-.3-.04L6.1 1.917l.444-.012c.145-.1.31-.075.47-.075a3896.2 3896.2 0 016.396 0c.16 0 .327-.026.47.076z",
  fill: "#B2B2A5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.103 2.004L14.498 2c-.112.138-.27.088-.41.088-2.524.002-5.048.002-7.572 0-.141 0-.298.049-.413-.083v-.001z",
  fill: "#CCCCBF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.613 3.114l-.004-.33c-.153-.122-.337-.082-.509-.083-1.528-.004-3.056 0-4.584-.004-.187 0-.385.043-.556-.077-.19-.003-.383.014-.57-.013-.422-.06-.557.124-.49.509-.182-.175-.057-.39-.08-.586.076-.061.167-.046.254-.046h6.372c.086 0 .178-.018.25.052-.027.193.09.405-.082.578h-.001z",
  fill: "#B78276"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.695 2.535L6.821 2.53c.093-.135.237-.09.362-.09 2.05-.002 4.102-.002 6.153.001.125 0 .27-.046.358.096h.001z",
  fill: "#F0BBAE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.657 3.462c-.947-.479-1.071-1.139-.356-1.88.074.05.122.112.121.204-.307.645-.295.927.047 1.225.097.084.233.12.296.243.018.096-.045.152-.108.207v.001z",
  fill: "#D97874"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.391 1.742c-.067-.032-.088-.09-.09-.16.602-.399 1.287-.223 1.6.41.032.084-.018.116-.088.135-.098 0-.167-.057-.221-.124-.267-.322-.598-.392-.986-.259-.07.024-.143.034-.214-.002z",
  fill: "#DD7469"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.783 2.098l.116-.106c.312.676.06 1.196-.715 1.478-.043-.092-.024-.182.004-.272.449-.236.48-.69.595-1.1z",
  fill: "#D37E72"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.334 1.557c-.044-.062-.061-.075-.06-.084a.792.792 0 01.372-.546c.053-.034.113.024.106.088-.026.274-.275.353-.42.542h.002z",
  fill: "#C3D0C3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.173 3.303c.104.05.03.11.01.168l-.526-.008c0-.068.024-.124.09-.156.14-.12.283-.118.426-.004z",
  fill: "#E6725C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.19 1.394c-.03.169-.115.328-.08.507-.105-.19-.232-.383.08-.507z",
  fill: "#DA8A7E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.125 6.098c-.015-.904.353-1.323 1.079-1.228a.7.7 0 01.518 1.056.656.656 0 01-.109.074c-.103.035-.212.034-.32.035-.2-.003-.406 0-.575-.134-.157-.124-.227-.042-.275.106a.303.303 0 01-.135.13c-.068.019-.13.012-.183-.039z",
  fill: "#314357"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.727 6.096c.295.137.191.331.079.527a.5.5 0 00-.265.356l-.187.433c-.379.266-.507.252-.785-.089-.069-.039-.092-.102-.097-.176a.384.384 0 01.158-.142c.284-.152.488-.345.41-.705-.013-.067.027-.138.06-.203a.225.225 0 01.132-.112c.17.002.234.168.367.228.193.123-.02-.192.128-.116z",
  fill: "#E7A897"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.183 6.097c-.021.084-.079.178-.058.25.162.576-.275.662-.653.8a.549.549 0 01-.176-.354c-.154-.233-.17-.465.003-.697L2.367 6c.277-.015.564-.1.815.098h.001z",
  fill: "#EFA592"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.558 7.834l.024-.255c.254-.021.509-.018.764-.004l.026.171c-.012.103-.085.17-.148.244-.102.071-.136.242-.31.212L2.912 8.2c-.109-.108-.254-.176-.341-.309l-.013-.057z",
  fill: "#EEA28D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.914 8.2c.092-.087.126-.23.268-.268.11-.052.197-.185.347-.09l.102.244c-.231.084-.444.283-.717.115z",
  fill: "#8D898D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.298 6.095l-.002.697c-.354-.16-.331-.41-.17-.694l.172-.003z",
  fill: "#CBA5A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.346 7.574a.925.925 0 01-.763.004l-.015-.255c.237.238.51.171.786.088l-.008.162z",
  fill: "#D17C6D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.74 8.254l-.45-.165c.049-.127.017-.337.27-.256l.011.03c.062.128.356.157.17.39z",
  fill: "#8595A2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.54 6.979c-.011-.191-.024-.383.266-.356-.015.172-.193.226-.266.356z",
  fill: "#E6A59B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.727 6.096c-.06.046.087.22-.113.178-.084-.117-.084-.232.011-.343l.097-.005.005.17z",
  fill: "#653F3C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.529 7.841l-.347.091a.323.323 0 01.19-.186c.068.006.137.01.157.096z",
  fill: "#B9A19F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.88 1.905H6.545c.038-.215.212-.163.348-.163 2.212-.002 4.426-.002 6.639 0 .136 0 .31-.052.347.163h.001z",
  fill: "#EC6C59"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.96 2.619c1.772-.003 3.543-.006 5.316-.005.133 0 .313-.059.334.169-1.753 0-3.506.003-5.259 0-.144 0-.343.08-.39-.164z",
  fill: "#EC6A59"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.74 8.254c.055-.177-.165-.238-.17-.39.156.07.363.089.343.335l-.173.055z",
  fill: "#8D898D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.173 3.303l-.427.004c-.771-.353-.89-1.025-.355-1.564.638-.315.965-.232 1.393.356.107.555-.09.96-.61 1.204z",
  fill: "#FBC9B1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.183 6.097c-.258-.141-.569.132-.815-.098l.044-.424c.299.139.503.447.86.358.02.019.027.036.02.054-.007.017-.014.026-.021.026l-.089.083.001.001z",
  fill: "#D4A6A2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.27 6.014v-.08l.354-.003-.011.343c-.225.055-.218-.187-.343-.26z",
  fill: "#CFA8A5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.902 6.262c.005.235.066.383-.089.52-.117-.188.007-.302.089-.52z",
  fill: "#E0977C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.277 2.79c-.264.303-.53.198-.75-.032-.213-.224-.182-.492.045-.694.216-.194.482-.242.71-.014.233.236.292.497-.005.742a.25.25 0 00-.144-.086.285.285 0 01.145.084h-.001z",
  fill: "#E46F63"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.277 2.79c-.158-.03-.336.056-.577-.15.275-.002.465-.154.576.151z",
  fill: "#F5645A"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "step1_svg__clip0_193_15663"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v10.024H0z"
})));

function SvgStep1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgStep1;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/step1.svg
// module id = 1312
// module chunks = 10